<template>
  <div class="container">
    <div class="menus">
      <div
        v-for="item in menus"
        :key="item.value"
        class="menus-item"
        :class="{ active: item.value == is_active }"
        @click="changeItem(item)"
      >
        <div class="menus-item-news">
          {{ $t(item.title) }}
          <div class="num" v-if="item.news" ref="menus1">
            {{ item.news }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      is_active: 0,
      menus: [
        {
          value: 0,
          title: 'lang.external.personal.nav.实验成绩',
          path: '/personalCenter/experimentalScore',
          news: 0,
        },
        {
          value: 1,
          title: 'lang.external.personal.nav.实验报告',
          path: '/personalCenter/experimentalReport',
          news: 0,
        },
        {
          value: 2,
          title: 'lang.external.personal.nav.我的作品',
          path: '/personalCenter/myWork',
          news: 0,
        },
        {
          value: 3,
          title: 'lang.external.personal.nav.已学课程',
          path: '/personalCenter/learned',
          news: 0,
        },
        {
          value: 4,
          title: 'lang.external.personal.nav.我的问题',
          path: '/personalCenter/myQuestion',
          news: 0,
        },
        {
          value: 5,
          title: 'lang.external.personal.nav.个人信息',
          path: '/personalCenter/myInfo',
          news: 0,
        },
        {
          value: 6,
          title: 'lang.external.personal.nav.账号安全',
          path: '/personalCenter/accountSecurity',
          news: 0,
        },
      ],
    }
  },
  mounted() {
    this.changeActive()
    this.menus[4].news = this.questionShow
  },
  computed: {
    ...mapState({
      questionShow: (state) => state.personal.questionShow,
    }),
  },
  watch: {
    questionShow: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.menus[4].news = newValue
      }
    },
  },
  methods: {
    changeItem(v) {
      this.is_active = v.value
      this.$emit('change', v.title)
      if (v.title !== this.$t('lang.external.personal.nav.实验成绩')) {
        this.$store.commit('SET_CRUMBS', undefined)
      }

      if (this.$route.path !== v.path) this.$router.push(v.path)
    },
    changeActive() {
      this.menus.map((v) => {
        if (v.path === this.$route.path) {
          this.is_active = v.value
          this.$emit('change', v.title)
        }
      })
    },
  },
  created() {},
}
</script>
<style lang="scss" scoped>
.container {
  width: 20%;
  padding-right: 20px;
  .menus {
    width: 100%;
    background-color: #fff;
    border: solid 1px #fafbfc;
    border-radius: 4px;
    &-item {
      display: flex;
      justify-content: center;
      cursor: pointer;
      color: #666666;
      border-top: 1px solid #eaeaea;
      &-news {
        position: relative;
        font-size: 16px;
        line-height: 46px;
        .num {
          position: absolute;
          top: 50%;
          right: -30px;
          transform: translateY(-50%);
          width: 25px;
          height: 14px;
          font-size: 12px;
          line-height: 14px;
          text-align: center;
          color: #fff;
          background: #a63528;
          border-radius: 9px;
        }
      }
      &:first-child {
        border-top: 0;
        border-radius: 4px 4px 0 0;
      }
      &:last-child {
        border-radius: 0 0 4px 4px;
      }
    }
    .active {
      background-color: #0c5893;
      color: #fff;
    }
  }
}
</style>